var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecutetdTripscrcle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 101.574,
    viewBox: "0 0 104 101.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_228",
    x: 0,
    y: 0.574,
    width: 104,
    height: 101,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.904,
    y1: 0.58,
    x2: -0.441,
    y2: 0.116,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34fe92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#69dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#a4c496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da9dd5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "executetd_tripscrcle",
    transform: "translate(-384.379 -1260.426)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 384.38, 1260.43)",
    filter: "url(#Ellipse_228)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_228-2",
    "data-name": "Ellipse 228",
    cx: 43,
    cy: 41.5,
    rx: 43,
    ry: 41.5,
    transform: "translate(9 6.57)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10108",
    "data-name": "Group 10108",
    transform: "translate(0.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11928",
    "data-name": "Path 11928",
    d: "M47.364,113.618s.571-3.155,2.817,4.264,27.645,23.658,36.147,10.507,20.523,1.606,28.826-2.341,9.618-9.155,3.429-21.706,9.035-27.845-6.14-37.678-3.428-7.417-3.428-7.417l-.077,40.143L88.624,117.807Z",
    transform: "translate(365 1227.795)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11929",
    "data-name": "Path 11929",
    d: "M107.593,74.546s-1.765-.1,2.143-1.853,11.08-16.947,3.312-20.771-.5-11.5-3.222-15.836-5.657-4.715-12.106-.429S78.828,28.5,74.472,37.584s3.044-1.946,3.044-1.946l18.145,5.708,11.444,10.021Z",
    transform: "translate(365 1227.795)",
    fill: "#69dfa7",
    fillRule: "evenodd",
    opacity: 0.518
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 39.854,
    cy: 39.854,
    r: 39.854,
    transform: "translate(397.5 1266.295)",
    fill: "none",
    stroke: "#b6f1ef",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11931",
    "data-name": "Path 11931",
    d: "M69.157,39.062A39.854,39.854,0,1,1,36.8,97.782",
    transform: "translate(365.5 1227.324)",
    fill: "none",
    stroke: "#51b4b0",
    strokeLinecap: "round",
    strokeWidth: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutetdTripscrcle);
export default __webpack_public_path__ + "static/media/executetd_tripscrcle.1c97193f6972b4cfc61157601bfade6b.svg";
export { ForwardRef as ReactComponent };